
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 14 12"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{attrs:{"fill":"currentColor","d":"M8.26709.207606L13.7671 5.45761c.1484.14159.2324.33787.2324.54296 0 .2051-.084.40138-.2324.54297L8.26709 11.7935c-.29981.2852-.7744.2744-1.06056-.0254-.28612-.2968-.27537-.7734.02541-1.0605l4.14586-3.95703H.75c-.414062 0-.75-.33593-.75-.75 0-.41406.335938-.75.75-.75h10.6278L7.23194 1.29354c-.30078-.28612-.31153-.762684-.02541-1.060559.28616-.2997817.76075-.3105316 1.06056-.025375z"}})])
          )
        }
      }
    